import classNames from "classnames";
import { DatasetStatusEnum } from "types";
import styles from "./style.module.scss";
import { Tooltip, Typography } from "antd";
import { useNavigate } from "react-router";

/**
 * @deprecated this function is deprecated use useUserConfig hook instead
 */
const DeprecatedDatasetStatusComponent = ({
  datasetStatus,
  icon,
  onClick,
  datasetId,
}: DatasetStatusProps) => {
  const navigate = useNavigate();

  const statusButtonClassnames = classNames(styles.statusButton, {
    [styles.readyButton]: datasetStatus === DatasetStatusEnum.READY,
    [styles.progressButton]: [
      DatasetStatusEnum.INDEXING,
      DatasetStatusEnum.UPLOADING,
      DatasetStatusEnum.ENRICHING,
      DatasetStatusEnum.PRE_PROCESSING,
      DatasetStatusEnum.SAVING,
      DatasetStatusEnum.UPDATING,
    ].includes(datasetStatus),
    [styles.initializingButton]: [
      DatasetStatusEnum.INITIALIZING,
      DatasetStatusEnum.NEW,
      DatasetStatusEnum.PENDING_INDEX,
    ].includes(datasetStatus),
    [styles.errorButton]: datasetStatus === DatasetStatusEnum.FATAL_ERROR,
    [styles.clickable]: !!onClick,
  });

  const { Link } = Typography;
  const statusButton = (
    <button className={statusButtonClassnames} onClick={onClick}>
      {datasetStatus.toLowerCase()}
      {icon}
    </button>
  );

  if (
    [DatasetStatusEnum.PENDING_INDEX, DatasetStatusEnum.READY].includes(
      datasetStatus,
    )
  ) {
    return statusButton;
  }

  return (
    <Tooltip
      title={
        <div className={styles.tooltipContent}>
          You can see more details in the{" "}
          <Link
            onClick={() => navigate(`/task-manager?dataset_id=${datasetId}`)}
          >
            Task Manager
          </Link>{" "}
          table
        </div>
      }
    >
      {statusButton}
    </Tooltip>
  );
};

export default DeprecatedDatasetStatusComponent;

interface DatasetStatusProps {
  datasetStatus: DatasetStatusEnum;
  icon?: React.ReactElement;
  onClick?: () => void;
  datasetId: string;
}
